import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type QueryProviderProps = {
  children?: React.ReactNode;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as any)?.status;
        if (status >= 400 && status < 500 && status !== 403) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
